import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ArrayResponse} from '../models/array-response';
import {SendBackResult} from '../models/send-back-result';

import {AppSettingsService} from './app-settings.service';
import {BaseRestService} from './base-rest.service';
import {SharedModule} from '..';
import {PlayerConfigurationEdit} from '../models/player-configuration';

@Injectable({
  providedIn: SharedModule
})
export class PlayerConfigurationEditService extends BaseRestService {
  constructor(http: HttpClient, appSettingsService: AppSettingsService) {
    super(http, appSettingsService);
  }

  protected get className(): string {
    return 'PlayerConfigurationEditService';
  }

  protected get isAnonymous(): boolean {
    return false;
  }

  getPlayerConfiguration(clientUuid: string, subscriptionUuid: string): Observable<SendBackResult<ArrayResponse<PlayerConfigurationEdit>>> {
    return this.get<ArrayResponse<PlayerConfigurationEdit>>(`/client/${clientUuid}/subscription/${subscriptionUuid}/playerConfiguration`);
  }

  getPlayerConfigurationClient(clientUuid: string): Observable<SendBackResult<ArrayResponse<PlayerConfigurationEdit>>> {
    return this.get<ArrayResponse<PlayerConfigurationEdit>>(`/client/${clientUuid}/playerConfiguration`);
  }

  update(clientUuid: string, subscriptionUuid: string ,
         playerConfig: PlayerConfigurationEdit[]): Observable<SendBackResult<ArrayResponse<PlayerConfigurationEdit>>> {
    return this.put<ArrayResponse<PlayerConfigurationEdit>>(`/client/${clientUuid}/subscription/${subscriptionUuid}/playerConfiguration`
      , playerConfig);
  }

  updateClient(clientUuid: string, playerConfig: PlayerConfigurationEdit[]): Observable<SendBackResult<ArrayResponse<PlayerConfigurationEdit>>> {
    return this.put<ArrayResponse<PlayerConfigurationEdit>>(`/client/${clientUuid}/playerConfiguration`
      , playerConfig);
  }


}
